import styled from 'styled-components';
import { breakpoints, getSpacing } from 'stylesheet';

export const Styles = {
  Content: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  ButtonWrapper: styled.div`
    margin-top: ${getSpacing(45)};
    @media (max-width: ${breakpoints.small}) {
      margin-top: ${getSpacing(20)};
    }
  `,
};
